import {
  useState,
  useRef,
  useLayoutEffect,
  useEffect,
  cloneElement,
} from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import { colors } from "common/const/colors";

export function PopoverTrigger({ children, popoverContent, isShowPopover }) {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  const popoverRef = useRef(null);
  const [bg, setBg] = useState("rgba(255,255,255,0.8)");

  const showPopover = () => {
    if (!triggerRef.current || !isShowPopover) return;
    if (isOpen) return;

    const rect = triggerRef.current.getBoundingClientRect();
    setPosition({
      top: rect.top,
      left: rect.left,
    });
    setIsOpen(true);
  };

  useLayoutEffect(() => {
    if (!isOpen || !popoverRef.current || !triggerRef.current) return;

    const popoverWidth = popoverRef.current.offsetWidth;
    const rect = triggerRef.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    let left = rect.left;

    if (rect.left + popoverWidth > viewportWidth) {
      left = rect.right - popoverWidth;
      if (left < 0) left = 0;
    }

    setPosition((prev) => ({ ...prev, left }));
  }, [isOpen]);

  const hidePopover = (e) => {
    const related = e.relatedTarget;
    if (
      (triggerRef.current &&
        related instanceof Node &&
        triggerRef.current.contains(related)) ||
      (popoverRef.current &&
        related instanceof Node &&
        popoverRef.current.contains(related))
    ) {
      return;
    }
    setIsOpen(false);
  };

  return (
    <>
      <div
        style={{ display: "contents" }}
        onMouseEnter={showPopover}
        onMouseLeave={hidePopover}>
        {cloneElement(children, {
          ref: triggerRef,
          onMouseEnter: showPopover,
          onMouseLeave: hidePopover,
        })}
      </div>

      {isOpen &&
        popoverContent &&
        popoverContent.length > 0 &&
        createPortal(
          <PopoverContainer
            ref={popoverRef}
            style={{
              top: position.top,
              left: position.left,
              backgroundColor: bg,
            }}
            onMouseLeave={hidePopover}>
            {popoverContent}
          </PopoverContainer>,
          document.body
        )}
    </>
  );
}

const PopoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  width: max-content;
  z-index: 10;
  padding: 1.25rem;
  gap: 1.5rem;
  border-radius: 0.5rem;
  background-color: ${colors.withOpacity(colors.White, 0.8)};
  box-shadow: 0 2px 6px rgba(20, 14, 14, 0.2);
  backdrop-filter: blur(4px);
  pointer-events: auto;
  transform: translateY(-100%);
`;
